// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"
import Collection from "@kaspernj/api-maker/build/collection.js"
import CheckInAudit from "./check-in-audit.js"
import CheckInClassStep from "./check-in-class-step.js"
import Course from "./course.js"
import Survey from "./survey.js"

const modelClassData = {
  "attributes": {
    "created_at": {
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      },
      "name": "created_at",
      "selected_by_default": null,
      "translated": true
    },
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": null
      },
      "name": "id",
      "selected_by_default": null,
      "translated": true
    },
    "public": {
      "column": {
        "default": "0",
        "name": "public",
        "null": false,
        "type": "boolean"
      },
      "name": "public",
      "selected_by_default": null,
      "translated": false
    },
    "survey_id": {
      "column": {
        "default": null,
        "name": "survey_id",
        "null": false,
        "type": null
      },
      "name": "survey_id",
      "selected_by_default": null,
      "translated": false
    },
    "updated_at": {
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      },
      "name": "updated_at",
      "selected_by_default": null,
      "translated": true
    },
    "name": {
      "column": null,
      "name": "name",
      "selected_by_default": false,
      "translated": true
    },
    "name_da": {
      "column": null,
      "name": "name_da",
      "selected_by_default": false,
      "translated": false
    },
    "name_en": {
      "column": null,
      "name": "name_en",
      "selected_by_default": false,
      "translated": false
    },
    "name_no": {
      "column": null,
      "name": "name_no",
      "selected_by_default": false,
      "translated": false
    },
    "name_se": {
      "column": null,
      "name": "name_se",
      "selected_by_default": false,
      "translated": false
    }
  },
  "className": "CheckIn",
  "collectionKey": "check_ins",
  "collectionName": "check_ins",
  "i18nKey": "check_in",
  "camelizedLower": "checkIn",
  "name": "CheckIn",
  "nameDasherized": "check-in",
  "pluralName": "check_ins",
  "ransackable_associations": [
    {
      "className": "CheckIn::Audit",
      "collectionName": "check_in_audits",
      "foreignKey": "check_in_id",
      "name": "audits",
      "macro": "has_many",
      "resource_name": "CheckInAudit",
      "through": null
    },
    {
      "className": "CheckInClassStep",
      "collectionName": "check_in_class_steps",
      "foreignKey": "check_in_id",
      "name": "check_in_class_steps",
      "macro": "has_many",
      "resource_name": "CheckInClassStep",
      "through": null
    },
    {
      "className": "ClassStep",
      "collectionName": "class_steps",
      "foreignKey": "class_step_id",
      "name": "class_steps",
      "macro": "has_many",
      "resource_name": "ClassStep",
      "through": "check_in_class_steps"
    },
    {
      "className": "Course",
      "collectionName": "courses",
      "foreignKey": "course_id",
      "name": "course",
      "macro": "belongs_to",
      "resource_name": "Course",
      "through": null
    },
    {
      "className": "CheckIn::Audit",
      "collectionName": "check_in_audits",
      "foreignKey": "check_in_id",
      "name": "create_audit",
      "macro": "has_one",
      "resource_name": "CheckInAudit",
      "through": null
    },
    {
      "className": "CheckIn::Translation",
      "collectionName": null,
      "foreignKey": "check_in_id",
      "name": "current_translation",
      "macro": "has_one",
      "resource_name": null,
      "through": null
    },
    {
      "className": "SchoolClassCheckIn",
      "collectionName": "school_class_check_ins",
      "foreignKey": "check_in_id",
      "name": "school_class_check_ins",
      "macro": "has_many",
      "resource_name": "SchoolClassCheckIn",
      "through": null
    },
    {
      "className": "Survey",
      "collectionName": "surveys",
      "foreignKey": "survey_id",
      "name": "survey",
      "macro": "belongs_to",
      "resource_name": "Survey",
      "through": null
    },
    {
      "className": "CheckIn::Translation",
      "collectionName": null,
      "foreignKey": "check_in_id",
      "name": "translations",
      "macro": "has_many",
      "resource_name": null,
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "course_id",
      "column": {
        "default": null,
        "name": "course_id",
        "null": true,
        "type": null
      }
    },
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": null
      }
    },
    {
      "name": "public",
      "column": {
        "default": "0",
        "name": "public",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "survey_id",
      "column": {
        "default": null,
        "name": "survey_id",
        "null": false,
        "type": null
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    }
  ],
  "ransackable_scopes": [],
  "relationships": [
    {
      "className": "CheckInClassStep",
      "collectionName": "check_in_class_steps",
      "foreignKey": "check_in_id",
      "name": "check_in_class_steps",
      "macro": "has_many",
      "resource_name": "CheckInClassStep",
      "through": null
    },
    {
      "className": "Course",
      "collectionName": "courses",
      "foreignKey": "course_id",
      "name": "course",
      "macro": "belongs_to",
      "resource_name": "Course",
      "through": null
    },
    {
      "className": "CheckIn::Audit",
      "collectionName": "check_in_audits",
      "foreignKey": "check_in_id",
      "name": "create_audit",
      "macro": "has_one",
      "resource_name": "CheckInAudit",
      "through": null
    },
    {
      "className": "Survey",
      "collectionName": "surveys",
      "foreignKey": "survey_id",
      "name": "survey",
      "macro": "belongs_to",
      "resource_name": "Survey",
      "through": null
    }
  ],
  "paramKey": "check_in",
  "primaryKey": "id"
}

/** Frontend model for CheckIn. */
export default class CheckIn extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {Date} */
  createdAt() {
    return this.readAttributeUnderscore("created_at")
  }

  /** @returns {boolean} */
  hasCreatedAt() {
    const value = this.createdAt()

    return this._isPresent(value)
  }

  /** @returns {any} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {boolean} */
  public() {
    return this.readAttributeUnderscore("public")
  }

  /** @returns {boolean} */
  hasPublic() {
    const value = this.public()

    return this._isPresent(value)
  }

  /** @returns {any} */
  surveyId() {
    return this.readAttributeUnderscore("survey_id")
  }

  /** @returns {boolean} */
  hasSurveyId() {
    const value = this.surveyId()

    return this._isPresent(value)
  }

  /** @returns {Date} */
  updatedAt() {
    return this.readAttributeUnderscore("updated_at")
  }

  /** @returns {boolean} */
  hasUpdatedAt() {
    const value = this.updatedAt()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  name() {
    return this.readAttributeUnderscore("name")
  }

  /** @returns {boolean} */
  hasName() {
    const value = this.name()

    return this._isPresent(value)
  }

  /** @returns {any} */
  nameDa() {
    return this.readAttributeUnderscore("name_da")
  }

  /** @returns {boolean} */
  hasNameDa() {
    const value = this.nameDa()

    return this._isPresent(value)
  }

  /** @returns {any} */
  nameEn() {
    return this.readAttributeUnderscore("name_en")
  }

  /** @returns {boolean} */
  hasNameEn() {
    const value = this.nameEn()

    return this._isPresent(value)
  }

  /** @returns {any} */
  nameNo() {
    return this.readAttributeUnderscore("name_no")
  }

  /** @returns {boolean} */
  hasNameNo() {
    const value = this.nameNo()

    return this._isPresent(value)
  }

  /** @returns {any} */
  nameSe() {
    return this.readAttributeUnderscore("name_se")
  }

  /** @returns {boolean} */
  hasNameSe() {
    const value = this.nameSe()

    return this._isPresent(value)
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./check-in-class-step.js").default>} */
  checkInClassSteps() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["check_in_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "check_in_class_steps",
        model: this,
        modelClass: CheckInClassStep
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./check-in-class-step.js").default>>} */
  loadCheckInClassSteps() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["check_in_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "check_in_class_steps",
        model: this,
        modelClass: CheckInClassStep
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./check-in-class-step.js").default>>} */
  ensureCheckInClassStepsLoaded() {
    return this.ensureAssociationLoaded("check_in_class_steps")
  }

  /** @returns {import("./course.js").default | null} */
  course() {
    return this._readBelongsToReflection({modelClass: Course, reflectionName: "course"})
  }

  /** @returns {Promise<import("./course.js").default | null>} */
  loadCourse() {
    if (!("courseId" in this)) throw new Error("Foreign key method wasn't defined: courseId")

    const id = this.courseId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "course",
        model: this,
        modelClass: Course
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./course.js").default | null>} */
  ensureCourseLoaded() {
    return this.ensureAssociationLoaded("course")
  }

  /** @returns {import("./check-in-audit.js").default | null} */
  createAudit() {
    return this._readHasOneReflection({modelClass: CheckInAudit, reflectionName: "create_audit"})
  }

  /** @returns {Promise<import("./check-in-audit.js").default | null>} */
  loadCreateAudit() {
    if (!("id" in this)) throw new Error("Primary key method wasn't defined: id")

    const id = this.id()
    const ransack = {}

    ransack["check_in_id_eq"] = id

    return this._loadHasOneReflection(
      {
        reflectionName: "create_audit",
        model: this,
        modelClass: CheckInAudit
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./check-in-audit.js").default | null>} */
  ensureCreateAuditLoaded() {
    return this.ensureAssociationLoaded("create_audit")
  }

  /** @returns {import("./survey.js").default | null} */
  survey() {
    return this._readBelongsToReflection({modelClass: Survey, reflectionName: "survey"})
  }

  /** @returns {Promise<import("./survey.js").default | null>} */
  loadSurvey() {
    if (!("surveyId" in this)) throw new Error("Foreign key method wasn't defined: surveyId")

    const id = this.surveyId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "survey",
        model: this,
        modelClass: Survey
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./survey.js").default | null>} */
  ensureSurveyLoaded() {
    return this.ensureAssociationLoaded("survey")
  }
}
